import _slicedToArray from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { jsx } from 'react/jsx-runtime';
import { useState, useRef, useMemo } from 'react';
import { TabsContext } from './use-tabs.js';
import s from './Tabs.module.scss.js';
var Tabs = function Tabs(_ref) {
  var children = _ref.children;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  var tabsRef = useRef([]);
  var contextValue = useMemo(function () {
    return {
      activeTab: activeTab,
      setActiveTab: setActiveTab,
      tabsRef: tabsRef
    };
  }, [activeTab, setActiveTab, tabsRef]);
  return /* @__PURE__ */jsx(TabsContext.Provider, {
    value: contextValue,
    children: /* @__PURE__ */jsx("div", {
      className: s.tabs,
      children: children
    })
  });
};
export { Tabs };